<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <a class="decoration">Rental</a>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <router-link class="decoration" to="/rental/return/index">Rental Return List</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Create Rental GRN
      </h6>

      <div style="padding-bottom: 160px;" class="container-fluid">
        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body custom_bdr_rds">
            <form @submit.prevent="saveReturn()">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group required">
                    <label class="custom-label" style="font-size: small;">Received Date</label>
                    <input type="date" v-model="grn.return_date" style="font-size: small;" class="form-control" required />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group required">
                    <label class="custom-label" style="font-size: small;">Rental GIN</label>
                    <v-select class="font-size_def" label="label" :options="rentalGins" v-model="selectedGin" @input="loadGinDetails"></v-select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="custom-label" style="font-size: small;">Customer</label>
                    <input v-model="grn.customer_name" style="font-size: small;" class="form-control" readonly />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label class="custom-label" style="font-size: small;">Remarks</label>
                    <textarea v-model="grn.remarks" class="form-control" rows="2"></textarea>
                  </div>
                </div>
              </div>

              <div class="card custom_bdr_rds">
                <div class="card-body custom_bdr_rds">
                  <h6 class="purchitem mb-2"><b>Return Rental Unit List</b></h6>
                  <div class="table-responsive mb-1">
                    <table style="font-size: small;" class="table table-sm table-hover">
                      <thead class="background_color2">
                        <tr>
                          <th class="custom-label2">#</th>
                          <th class="custom-label2">Return</th>
                          <th class="custom-label2">Model</th>
                          <th class="custom-label2">Engine No.</th>
                          <th class="custom-label2">Chassis No.</th>
                          <th class="custom-label2">Color</th>
                          <th class="custom-label2">From Date</th>
                          <th class="custom-label2">To Date</th>
                          <th class="custom-label2">Return Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(detail, index) in details" :key="detail.id">
                          <td>{{ index + 1 }}</td>
                          <td><input type="checkbox" v-model="detail.selected" /></td>
                          <td>{{ detail.model_name }}</td>
                          <td>{{ detail.engine_no }}</td>
                          <td>{{ detail.chassis_no }}</td>
                          <td>{{ detail.color }}</td>
                          <td>{{ detail.from_date }}</td>
                          <td>{{ detail.to_date }}</td>
                          <td><input type="date" v-model="detail.return_date" class="form-control" style="font-size: small;" /></td>
                        </tr>
                        <tr v-if="details.length === 0">
                          <td colspan="9" class="text-center">No pending rental units selected.</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div style="border-bottom: 0; padding-top: 0;" class="navbar">
                <div class="d-flex"></div>
                <div class="d-flex">
                  <button type="submit" class="mr-1 btn btn-outline-primary mb-1 font-size_def bdr-rad">Create</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

export default {
  name: "RentalGrnCreate",
  components: {
    "v-select": vSelect,
    TopNavbar,
    ContentFooter,
  },
  data() {
    return {
      accessToken: authService.isLoggedIn(),
      userid: authService.isUserid(),
      rentalGins: [],
      selectedGin: null,
      grn: {
        return_date: new Date().toISOString().slice(0, 10),
        rental_gin_id: "",
        customer_name: "",
        remarks: "",
      },
      details: [],
    };
  },
  mounted() {
    this.loadRentalGins();
  },
  methods: {
    headers() {
      return {
        Authorization: "Bearer " + this.accessToken,
        "Content-type": "application/json",
      };
    },
    async loadRentalGins() {
      try {
        const { data } = await axios.get("/rentalgin/returngins", {
          headers: this.headers(),
        });
        this.rentalGins = data.items || [];
      } catch (error) {
        console.log(error.response || error);
        this.rentalGins = [];
      }
    },
    async loadGinDetails() {
      if (!this.selectedGin) {
        this.details = [];
        return;
      }

      this.grn.rental_gin_id = this.selectedGin.id;
      this.grn.customer_name = this.selectedGin.customer_name;

      try {
        const { data } = await axios.get("/rentalgin/returngindetails?id=" + this.selectedGin.id, {
          headers: this.headers(),
        });
        this.details = (data.details || []).map((detail) => ({
          ...detail,
          selected: true,
          return_date: this.grn.return_date,
        }));
      } catch (error) {
        console.log(error.response || error);
        this.details = [];
      }
    },
    async saveReturn() {
      try {
        const { data } = await axios.post("/rentalgin/createreturn", {
          userid: this.userid,
          grn: this.grn,
          details: this.details,
        }, {
          headers: this.headers(),
        });

        if (data.status === 200) {
          this.$router.push("/rental/return/index");
        } else if (data.message) {
          alert(data.message);
        }
      } catch (error) {
        console.log(error.response || error);
      }
    },
  },
};
</script>
